import { useMutation } from "@tanstack/react-query";

import taxonomiesApi from "./api";

const useUpdateTaxonomy = options =>
  useMutation({ mutationFn: taxonomiesApi.update, ...options });

const useBulkDestroyTaxonomies = options =>
  useMutation({ mutationFn: taxonomiesApi.bulkDestroy, ...options });

export { useUpdateTaxonomy, useBulkDestroyTaxonomies };
